import React from "react";
import cn from "classnames";
import _take from "lodash/take";
import _get from "lodash/get";
import { buildUrl, getEnv } from "shared/utils";
import Icon from "backpack-ui/dist/components/icon";
import MaterialIcons from "./icons";
import styles from "./styles.css";

export const getResultIcon = (type, subtype) => {
  let ResultIcon = Icon.Map;
  const icons = {
    article: MaterialIcons.Description,
    lodging: MaterialIcons.LocalHotel,
    narratives: MaterialIcons.Description,
    news: MaterialIcons.Description,
    partner_activity: MaterialIcons.LocalActivity,
    place: Icon.Pin,
    product: MaterialIcons.Book,
    "thorntree-topic": MaterialIcons.Forum,
    video: MaterialIcons.LocalMovies,
  };

  if (icons[type]) {
    ResultIcon = icons[type];
  } else if (type === "poi") {
    const poiIcons = {
      Activities: MaterialIcons.LocalActivity,
      Attractions: MaterialIcons.PhotoCamera,
      Entertainment: MaterialIcons.LocalActivity,
      Events: Icon.Calendar,
      Hotels: MaterialIcons.LocalHotel,
      Information: Icon.Info,
      Nightlife: MaterialIcons.LocalBar,
      Restaurants: MaterialIcons.Restaurant,
      Shopping: MaterialIcons.LocalMall,
      Transportation: MaterialIcons.DirectionsTransit,
    };
    if (poiIcons[subtype]) {
      ResultIcon = poiIcons[subtype];
    }
  }

  return <ResultIcon className={styles.resultIcon} />;
};

const Results = ({ className, searchResults, searchTerm, onClick }) => (
  <ul className={cn(styles.results, className)}>
    {_take(searchResults, 5).map((result) => {
      const title = _get(result, "highlights.title") || result.title;
      const parentName =
        _get(result, "highlights.parent-name") || result.parentName;
      const text = parentName ? `${title}, ${parentName}` : title;
      const handleClick = () => {
        onClick(result.swiftypeId);
      };

      const BASE_URL = "https://www.lonelyplanet.com";
      const SHOP_BASE_URL = "https://shop.lonelyplanet.com";

      const quickLinks = [
        { name: "Restaurants", url: `${BASE_URL}/a/poi-eat/${result.opId}` },
        { name: "Hotels", url: `${BASE_URL}/a/lod/${result.opId}` },
        { name: "Top things to do", url: `${BASE_URL}/a/poi/${result.opId}` },
        {
          name: "Guidebooks",
          url: `${SHOP_BASE_URL}/search?q=${result.title}`,
        },
      ];

      return (
        <li className={styles.resultItem} key={result.id}>
          <a
            href={result.url}
            className={styles.resultLink}
            onClick={handleClick}
          >
            {getResultIcon(result.opType, result.opSubtype)}

            <span
              className={styles.resultTitle}
              dangerouslySetInnerHTML={{ __html: text }}
            />
          </a>
          {result.opType === "place" &&
            (result.placeType === "city" ||
              result.placeType === "neighborhood") && (
              <div className={cn(styles.quickLinksWrapper)}>
                <ul>
                  {quickLinks.map((link, i) => (
                    <li key={i}>
                      <a
                        className={cn(
                          styles.quickLink,
                          styles.resultLink,
                          className
                        )}
                        href={link.url}
                      >
                        {`${link.name}`}
                      </a>
                    </li>
                  ))}
                </ul>
              </div>
            )}
        </li>
      );
    })}

    <li className={styles.resultItem}>
      <a
        href={buildUrl(getEnv("SEARCH_URL"), { query: { q: searchTerm } })}
        className={cn(styles.resultLink, styles.resultLinkAll)}
      >{`Show all results for “${searchTerm}”`}</a>
    </li>
  </ul>
);

export default Results;
